<div style="margin-top: 10px;">
  <form [formGroup]="packageForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row">
          <span class="__filter_icon" style="background-color: white;">
          </span>
          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create Package
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
          <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)" >
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="header">
                <div class="sorting_header">
                  <span mat-sort-header>Package Name</span>
                  <input placeholder="Search by Package Name" type="search" matInput
                    autocomplete="off" formControlName="name" class="mat-input-custom">
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">{{element.name}}</td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Package Type</span>
                    <mat-select formControlName="type" placeholder="Search by Type">
                      @for (type of packageTypes; track type) {
                        <mat-option [value]="type.key">
                          {{type.label}}
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">{{element.type}}</td>
              </ng-container>
              <ng-container matColumnDef="wooden">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Wooden</span>
                    <mat-select formControlName="wooden" placeholder="Search by Wooden Type">
                      @for (wooden of yesNoList; track wooden) {
                        <mat-option [value]="wooden.key">
                          {{wooden.label}}
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.wooden === true ? "Yes" : "No" }}</td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <div class="sorting_header">
                    <span mat-sort-header>Status</span>
                    <mat-select formControlName="status" placeholder="Search by Status">
                      @for (status of statusTypes; track status) {
                        <mat-option [value]="status.key">
                          {{status.label}}
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">{{element.status}}</td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="header">
                  <span mat-sort-header>Action</span></th>
                  <td mat-cell *matCellDef="let element">
                    <span class="__action_edit_icon" (click)="openForm(element)">
                      <mat-icon mat-cell>create</mat-icon>
                    </span>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="groupColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: groupColumns;"></tr>
              </table>
              </div>
            }

          </mat-card-content>
        </mat-card>
        @if (viewPermission) {
          <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [length]="totalPackageRecords"></mat-paginator>
        }
      </form>
    </div>